import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface ISearchState {
    searchText: string,
}

const initialState: ISearchState = {
    searchText: '',
};

const searchSlice = createSlice({
    name: "search",
    initialState,
    reducers: {
        updateSearchText(
            state: ISearchState,
            action: PayloadAction<string>
        ) {
            const newText = action.payload;
            state.searchText =newText
        }
    },
});

export const { updateSearchText } = searchSlice.actions;
export default searchSlice.reducer;
